// Options doc: https://github.com/fengyuanchen/compressorjs/blob/main/README.md#options

const defaultFitStrategy = ({ width, height }) => ({
  width,
  height
});

const fitCrop = ({ width, height }) => ({
  width,
  height,
  resize: 'cover'
});

const fitMax = ({ width, height }) => ({
  maxWidth: width,
  maxHeight: height
});

const fitClip = ({ width, height }) => ({
  width,
  height,
  maxWidth: width,
  maxHeight: height
});

const formatsList = {
  jpg: 'image/jpeg',
  png: 'image/png'
};

const fitStrategy = {
  crop: fitCrop,
  max: fitMax,
  clip: fitClip
};

const CompressorConfig = (props = {}) => {
  const { convertOptions } = props;
  const { quality, format, fit, width, height, transparency } = convertOptions || {};
  const options = width && height
    ? (fitStrategy[fit] || defaultFitStrategy)(convertOptions)
    : {};

  options.strict = true;
  options.checkOrientation = false;
  options.convertTypes = [];

  // compressor quality is less or equal 1
  if (quality) {
    options.quality = quality > 1 ? quality / 100.0 : quality;
  } else {
    options.quality = 1;
  }

  if (format && formatsList[format]) {
    options.mimeType = formatsList[format];
  }

  // Handle transparency
  // transparency previously only occurred when explicitly using the image editor
  // This check ensures transparency is removed even in headless/direct uploads
  // When the image editor is used AND saved, transparency removal happens there
  // This serves as a fallback when the editor isn't used or when edits are canceled
  if (transparency === false) {
    // Use beforeDraw callback to fill the canvas with white before drawing the image
    options.beforeDraw = (context) => {
      context.fillStyle = 'white';
      context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    };
  }

  return options;
};

export default CompressorConfig;
